import { useNavigate, useSearch } from '@tanstack/react-router'
import { z } from 'zod'
import { fallback } from '@tanstack/zod-adapter'

export const activityLogSearchSchema = z.object({
  'coin-tab': fallback(
    z.union([z.literal('gold-coins'), z.literal('sweep-coins')]),
    'gold-coins',
  )
    .default('gold-coins')
    .optional(),
})

export type ActivityLogTabValue = z.infer<
  typeof activityLogSearchSchema
>['coin-tab']

export const useActivityLogTabs = () => {
  const search = useSearch({ from: '/_app/activity-log' })
  const navigate = useNavigate({ from: '/activity-log' })

  const setCurrentTab = (value: ActivityLogTabValue) => {
    void navigate({
      search: (prev) => ({
        ...prev,
        'coin-tab': value,
      }),
      resetScroll: false,
      replace: true,
    })
  }

  return {
    currentTab: search['coin-tab'] || 'gold-coins',
    setCurrentTab,
  }
}
